/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  SaveButton,
  useNotify,
  useRecordContext,
  useRedirect,
} from 'react-admin';
import { getToken } from '../authentication/authProvider';
import { useFormContext, useWatch } from 'react-hook-form';

const isProdMod = process.env.NODE_ENV === 'production';

export const ClientSaveButton = () => {
  const redirect = useRedirect();
  const notify = useNotify();

  const { getValues, control } = useFormContext();

  const ValidateAndSaveToQuickbooks = async (e: any) => {
    const { id, ...data } = getValues();

    try {
      if (data.accounting_reference_id) {
        const result = await fetch(
          `${process.env.REACT_APP_PAPERMAN_API_URL}quickbooks/customers/${data.accounting_reference_id}`,
          {
            method: 'PATCH',
            headers: { 
              Authorization: `Bearer ${getToken()}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({...data, "id": id})
          },

        );

        if (result.status < 200 || result.status > 300) {
          const body = await result.json();
          const message = body.error?.Error?.[0]?.Detail ?? body.error;
          notify(
            `Error creating or updating customer in QuickBooks. \n ${
              message != null && message !== '' ? message : ''
            }`,
            {
              type: 'error',
              autoHideDuration: 5000,
              multiLine: true,
            }
          );
        }
      }
    } catch (e) {
      console.warn(e);
      notify(JSON.stringify(e));
    }
  };

  return (
    <SaveButton
      type="button"
      onClick={ValidateAndSaveToQuickbooks}
      //   mutationOptions={{
      //     onSuccess: async (response) => {
      //       try {
      //         if (response['lines'].length === 0) {
      //           notify(
      //             `Error creating or updating estimate in QuickBooks. \n You need to add one product at least.`,
      //             {
      //               type: 'error',
      //               autoHideDuration: 5000,
      //               multiLine: true,
      //             }
      //           );
      //         }
      //         else if (response['lines'].some((e : any) => e.tax == "")) {
      //           notify(
      //             `Error creating or updating estimate in QuickBooks. \n One or more Contract lines missing tax.`,
      //             {
      //               type: 'error',
      //               autoHideDuration: 5000,
      //               multiLine: true,
      //             }
      //           );
      //         }
      //         else {
      //           if (response.is_preneed && !response['lines'].some((e : any) => e.item == preneedId)) {
      //             notify(
      //               `Contract is missing Pre-Need Fee.`,
      //               {
      //                 type: 'info',
      //                 autoHideDuration: 5000,
      //                 multiLine: true,
      //               }
      //             );
      //           }
      //           const result = await fetch(
      //             `${process.env.REACT_APP_PAPERMAN_API_URL}quickbooks/estimates/${response.id}`,
      //             {
      //               method: 'POST',
      //               headers: { Authorization: `Bearer ${getToken()}` },
      //             }
      //           );
      //           if (result.status >= 200 && result.status < 300) {
      //             notify(
      //               'Estimate in QuickBooks created or updated successfully',
      //               {
      //                 type: 'success',
      //               }
      //             );
      //             redirect(`/contracts/${response.id}/show`);
      //           } else {
      //             const body = await result.json();
      //             const message = body.error?.Error?.[0]?.Detail ?? body.error;
      //             notify(
      //               `Error creating or updating estimate in QuickBooks. \n ${
      //                 message != null && message !== '' ? message : ''
      //               }`,
      //               {
      //                 type: 'error',
      //                 autoHideDuration: 5000,
      //                 multiLine: true,
      //               }
      //             );
      //           }
      //         }
      //       } catch (e) {
      //         console.warn(e);
      //         notify(JSON.stringify(e));
      //       }
      //     },
      //   }}
    />
  );
};
